'use client';

import { useStyleSchema } from '@components/styleSchema/StyleSchemaHandler';
import { BrandName } from '@models/color-schema.model';

export const BrandSelector = () => {
  const { setActiveBrand, brandNames, currentSchema } = useStyleSchema();
  
  const handleBrandChange = (brand: BrandName) => {
    setActiveBrand(brand);
  };
  
  // Capitalize brand name for display
  const formatBrandName = (brand: string) => {
    return brand.charAt(0).toUpperCase() + brand.slice(1);
  };

  // Prepare button styles based on current selection
  const getButtonStyle = (brand: BrandName) => {
    const isActive = currentSchema.name === brand;
    
    return {
      className: `px-3 py-1.5 text-xs transition-colors ${
        isActive 
          ? 'bg-primary-600 text-primary hover:bg-primary-700' 
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      } first:rounded-l-md last:rounded-r-md border-r border-gray-200 last:border-0`,
    };
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-xs text-gray-500">Brand:</span>
      <div className="inline-flex rounded-md shadow-sm">
        {brandNames.map((brand) => (
          <button
            key={brand}
            onClick={() => handleBrandChange(brand)}
            {...getButtonStyle(brand)}
          >
            {formatBrandName(brand)}
          </button>
        ))}
      </div>
    </div>
  );
};
